import { render, staticRenderFns } from "./RobotDiseaseAnalysis.vue?vue&type=template&id=c2b10b36&"
import script from "./RobotDiseaseAnalysis.vue?vue&type=script&lang=js&"
export * from "./RobotDiseaseAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports